export const SOFTLINE_SETTINGS_APP_OVERVIEW = 'appOverview';
